import React from 'react'

import { Box, Typography } from "@mui/material"


export default function rawDataColumn() {

	return {
		name: 'rawData',
		label: 'Raw Data',
		options: {
			headerAlign: 'left',
			setCellProps: () => ({
				sx: {
					width: '50%'
				}
			}),
			customBodyRowRenderLite: value => <Box>
				<Typography>{value}</Typography>
			</Box>,
		}
	}
}